// extracted by mini-css-extract-plugin
module.exports = {"share_compoment":"Share_share_compoment___pNYb","refer_modal":"Share_refer_modal__MQNFP","no_active_modal":"Share_no_active_modal___554K"};